import { useMemo } from "react";
import { useSupplierFilters } from "../contexts/SupplierFiltersContext";
import { useSuppliersQuery } from "./useSuppliersQuery";

export const useSuppliersData = () => {
  // ----- FILTERS FROM CONTEXT ----- //
  const {
    filters, setters, queryString, isDebouncing,
  } = useSupplierFilters();
  const { search } = filters;
  const { setSearch } = setters;

  // ----- QUERY PARAMS CONSTRUCTION ----- //
  const queryParams = useMemo(() => {
    if (!queryString) return {};

    const searchParams = new URLSearchParams(queryString);
    const q: Record<string, string> = {};

    // Global search filter
    const searchValue = searchParams.get("q[name_or_address_or_city_cont]");
    if (searchValue) {
      q.name_or_address_or_city_cont = searchValue;
    }

    return Object.keys(q).length > 0 ? { q } : {};
  }, [queryString]);

  // ----- TANSTACK QUERY DATA FETCHING ----- //
  const {
    suppliers: suppliersData,
    metadata,
    isLoading,
    error,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
  } = useSuppliersQuery(queryParams);

  // ----- MANAGEMENT OF THE LIST LOADING STATE ----- //
  const isInitialLoading = isLoading && suppliersData.length === 0;
  const listLoading = isInitialLoading || isDebouncing;

  return {
    search,
    setSearch,
    suppliersData,
    metadata,
    isLoading,
    error,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    listLoading,
    isFiltering: isDebouncing,
  };
};
